<div class="bg-[#212529] text-white">
  <div class="container mx-auto px-4 py-8">

    <!-- Title row -->
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-lg md:text-3xl font-semibold">{{ job()?.position }}</h1>
      </div>
    </div>
  </div>
</div>

<!-- Content Section -->
<div class="container mx-auto mt-4">
  <mat-tab-group [selectedIndex]="tabIndex()" (selectedTabChange)="handleTabChange($event)">
    <mat-tab label="Job Description">
      <!-- Job Description -->
      <p class="text-gray-600 leading-relaxed whitespace-pre-line mt-4">
        {{ job()?.job_description }}
      </p>

      <h3 class="text-2xl font-bold my-2 pb-3 border-b">Questions</h3>
      @for(question of job()?.questions; track question) {
      <p>{{question}}</p>
      } @empty {
        <p>No specific questions added.</p>
      }
    </mat-tab>
    <mat-tab label="Candidates">
      <div class="flex items-center justify-between mt-4 mb-4">
        <p class="text-lg md:text-2xl !font-bold">
          Candidates ({{candidates.length }})
        </p>
        <button mat-button [color]="availableCreds() > 0 ? 'primary' : ''"
          (click)="availableCreds() > 0 ? addCandidate.emit(null) : null" [class.opacity-50]="availableCreds() === 0"
          [matTooltip]="availableCreds() === 0 ? 'Credits required to add candidate' : ''">
          <mat-icon>{{ availableCreds() > 0 ? 'add' : 'lock' }}</mat-icon>
          {{ availableCreds() > 0 ? 'Add' : 'Locked' }}
        </button>
      </div>
      <div class="space-y-4">
        @if (loading()) {
        @for(skeleton of [1,2,3];track skeleton) {
        <div class="p-4 rounded-lg border border-gray-100 bg-white animate-pulse">
          <div class="flex items-center justify-between mb-3">
            <!-- Name skeleton -->
            <div class="h-5 bg-gray-200 rounded w-32"></div>
            <!-- Status skeleton -->
            <div class="h-6 bg-gray-200 rounded-full w-24 px-2 py-1"></div>
          </div>

          <!-- Action Buttons skeleton -->
          <div class="flex gap-2 mt-2">
            <!-- Copy button skeleton -->
            <div class="h-10 w-10 bg-gray-200 rounded-full"></div>
            <!-- Download/Review button skeleton -->
            <div class="h-10 w-20 bg-gray-200 rounded ml-auto"></div>
          </div>
        </div>
        }
        } @else {
        @for (candidate of candidates; track candidate.id) {
        <div class="p-4 rounded-lg border border-gray-100 hover:border-gray-200 transition-all bg-white">
          <div class="flex items-center justify-between mb-3">
            <span class="font-medium text-gray-800">{{ candidate?.candidate_name }}</span>
            <span [class]="getStatusClass(candidate?.status)" class="px-2 py-1 rounded-full text-xs font-medium">
              {{ !candidate?.interview_link?'Analyzing Resume':candidate?.status | titlecase }}
            </span>
          </div>

          <!-- Action Buttons -->
          <div class="flex gap-2 mt-2">
            @if (candidate?.interview_link && candidate?.status == 'pending') {
            @if(copied.includes(candidate?.interview_link)) {
            <button mat-button>
              <mat-icon class="mat-18">check</mat-icon>
              Copied
            </button>
            }@else {
            <button (click)="copyText(candidate?.interview_link)" mat-fab-button
              class="!flex items-center justify-center">
              <mat-icon>content_copy</mat-icon>
            </button>
            }
            }
            @if (candidate?.resume) {
            <button (click)="downloadResume(candidate?.resume)" mat-fab-button color="primary"
              class="!flex items-center justify-center">
              <mat-icon>file_download</mat-icon>
            </button>
            }
            @else {
            <button routerLink="/review" [queryParams]="{jobID: candidate?.job_id, candidateID: candidate?.id}"
              mat-button color="primary" class="ml-auto !flex items-center justify-center">
              Review
            </button>
            }
          </div>
        </div>
        }
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
